<template>
    <div class="reminders">
        <button class=" btn reminder_btn">
            <img src="assets/images/schedule.png" data-src="assets/images/schedule.png" class="lazyload">
        </button>
        <div class="reminders_block_bg">
            <div class="blk_header">
                <div class="blk_title">{{Lang.get('messages.reminders')}}</div>
                <!-- <div><a href="#"> View all </a></div> -->
            </div>
            <div class="reminders_items">

                <div class="reminder_item" v-if="!reminders.length">
                    <h6>{{Lang.get('messages.no_reminders')}}</h6>                    
                </div>

                <div class="reminder_item" v-for="reminder in reminders" :key="reminder.id">
                    <h6>{{reminder.type.name}}</h6>
                    <div class="d-flex flex-wrap dates">
                        <div class="badge">{{reminder.date | date('DD MMMM, YYYY ')}}</div>
                        <!-- <div class="badge">14 Novmber</div>
                        <div class="badge">4 December</div> -->
                    </div>
                    <p><span> Class : </span>{{reminder.class.full_name}}</p>
                    <p><span> Subject : </span>{{reminder.subject.name}}</p>
                    <h6>Dont miss It</h6>
                </div>

            </div>
        </div>
    </div>
</template>

<script>
    import Teachers from '@api/teacher.api';
    import {
        mapState
    } from 'vuex';

    export default {
        data() {
            return {
                reminders: [],
            }
        },

        computed: {
            ...mapState("users", ["user"]),
        },

        created() {
            /* Teachers.getReminders(this.user.teacher.id)
                .then(res => {
                    this.reminders = res.data.data;
                }); */
        },

        methods: {

        }
    };
</script>